export default "__VITE_ASSET__b1d9dec4__"